import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState } from './auth.types';
import { FirestoreUserModel } from '../../models/auth';

const initialState: AuthState = {
  firestoreUser: null,
  logged: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    firebaseUserUpdated: (state, action: PayloadAction<FirestoreUserModel>) => {
      state.firestoreUser = action.payload
    },
    resetUser: (state) => {
      state.firestoreUser = null;
    },
    setExternalTable: (state, action: PayloadAction<string>) => {
      if(state.firestoreUser) state.firestoreUser.current_external_active_dine_in_table_sitting = action.payload;
    },
    setUserLogged: (state, action: PayloadAction<boolean>) => {
      state.logged = action.payload;
    }
  }
});

export const {
  firebaseUserUpdated,
  resetUser,
  setExternalTable,
  setUserLogged,
} = authSlice.actions;

export default authSlice.reducer;
